// extracted by mini-css-extract-plugin
export default {"container":"SimpleCollapsable_container__oD8TK"};